import * as Sentry from '@sentry/nextjs'
import {
  DefaultError,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { postBid } from './postBid'

interface UsePostBidProps {
  baseURL: string
}

export function usePostBid({ baseURL }: UsePostBidProps) {
  const queryClient = useQueryClient()

  return useMutation<
    Awaited<ReturnType<typeof postBid>>,
    AxiosError<DefaultError>,
    Omit<Parameters<typeof postBid>[0], 'baseURL'>
  >({
    mutationFn: (props) =>
      postBid({
        ...props,
        baseURL,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['bids'],
      })
    },
    onError: (data) => {
      Sentry.captureException(data)
    },
  })
}
